export interface LandingCandidate {
  path: string
  permissions: string[]
}

export const LANDING_CANDIDATES: LandingCandidate[] = [
  { path: '/richieste-preventivo', permissions: ['workshop_quotes.respond'] },
  { path: '/dashboard',            permissions: ['dashboard.view'] },
  { path: '/operativo/work-orders', permissions: ['work_orders.operativo'] },
  { path: '/schede-lavoro',        permissions: ['work_orders.view', 'work_orders.view_own'] },
  { path: '/board-giornaliero',    permissions: ['board_giornaliero.view'] },
  { path: '/rda',                  permissions: ['purchase_requests.view'] },
  { path: '/ordini',               permissions: ['purchase_requests.receive'] },
]

export const LANDING_FALLBACK = '/profile'
